import { render, staticRenderFns } from "./VueGuspreadTableTrTd.vue?vue&type=template&id=144e5072&"
import script from "./VueGuspreadTableTrTd.vue?vue&type=script&lang=js&"
export * from "./VueGuspreadTableTrTd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports